<template>
  <div class="quickjump sticky">
    <span class="title">Jump</span>
    <span class="badge" v-scroll-to="{ el: '#title', offset: -150 }">Title</span>
    <span class="badge" v-scroll-to="{ el: '#details', offset: -150 }">Details</span>
    <span class="badge" v-scroll-to="{ el: '#source', offset: -150 }">Source</span>
    <span class="badge" v-scroll-to="{ el: '#booking', offset: -150 }">Booking</span>
    <span class="badge" v-scroll-to="{ el: '#packages', offset: -150 }">Packages</span>
    <span class="badge" v-scroll-to="{ el: '#sequence', offset: -150 }">Sequence</span>
    <span class="badge" v-scroll-to="{ el: '#contents', offset: -150 }">Contents Tabs</span>
    <span class="badge" v-scroll-to="{ el: '#voucher', offset: -150 }">E-Voucher</span>
    <span class="badge" v-scroll-to="{ el: '#cover', offset: -150 }">Cover</span>
    <span class="badge" v-scroll-to="{ el: '#gallery', offset: -150 }">Gallery</span>
  </div>
</template>

<script>
export default {
  props: {
    showKlook: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .title {
    margin-right: 1rem;
    color: rgba(0,0,0,0.35);
  }

  .badge {
    cursor: pointer;
    margin-right: 0.25rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    background-color: lightseagreen;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/products/partials/Quickjump.vue